/* eslint-disable react/no-unknown-property */
import React, { useEffect, useState } from 'react';
import { ReactComponent as EditIcon } from 'common/icons/edit.svg';
import { ReactComponent as TrashIcon } from 'common/icons/trash.svg';
import Button from 'common/components/Button';
import { useSearchParams } from 'react-router-dom';
import sendFetch from 'common/utils/fetch';
import { CircularProgress, Modal } from '@mui/material';
import { useTheme } from '@emotion/react';
import { AddRole } from './components/AddRole';
import { EditRole } from './components/EditRole';
import RoleTypes from 'common/types/RoleTypes';
import { useAuth } from 'common/context/AuthContext';

type RoleLineProps = {
  title: string;
  id: string;
  handleDelete: (id: string) => void;
  openEdit: (id: string) => void;
};

/*const roleList: RoleTypes[] = [
  {
    id: 'fdsa-aadf-asdf-asdf',
    name: 'Owner',
    role: 2,
  },
  {
    id: 'sadf-asdf-asdf-asdf',
    name: 'Administrator',
    role: 1,
  },
  {
    id: 'fdsa-asdf-asdf-asdf',
    name: 'Basic',
    role: 0,
  },

];*/


const RoleLine = ({ title = 'administrator', handleDelete, openEdit, id = 'asfd-asdf-asdf-asdf' }: RoleLineProps) => {
  return (
    <div id={id} className='role-line-wrapper'>
      <div className='role-line-name'>
        <h5>{title}</h5>
      </div>
      <div className='role-line-actions'>
        <div onClick={() => { openEdit(id); }} className='role-line-icon'>
          <EditIcon className='svg-black' height={24 + 'px'} width={24 + 'px'} />

        </div>
        <div onClick={() => { handleDelete(id); }} className='role-line-icon'>
          <TrashIcon className='svg-black' height={24 + 'px'} width={24 + 'px'} />
        </div>
      </div>
    </div>
  );
};

export function RolesTab() {
  const theme = useTheme();
  const { companyId } = useAuth();
  const [roleList, setRoleList] = useState<RoleTypes[]>([]);
  const [searchParams, setSearchParams] = useSearchParams();
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedId, setSelectedId] = useState('' as string);
  const [loading, setLoading] = useState(false);
  const currentPage = searchParams.get('page');
  const handlePageChange = (page: string) => {
    searchParams.set('page', page);
    setSearchParams(searchParams);
  };
  useEffect(() => {
    const getRoles = async () => {
      const formData = new FormData();
      formData.append('companyId', companyId);
      const response: [number, RoleTypes[]] = await sendFetch('https://api-workspace.astin.net/api/company-role/get-all-roles', {
        method: 'POST',
        data: formData,
      });
      if (response[0] === 200) {
        setLoading(false);
        setRoleList(response[1]);
      }
    };
    setLoading(true);
    getRoles();
  }, [companyId]);
  const updateRoleList = async () => {
    const formData = new FormData();
    formData.append('companyId', companyId);
    const response: [number, RoleTypes[]] = await sendFetch('https://api-workspace.astin.net/api/company-role/get-all-roles', {
      method: 'POST',
      data: formData,
    });
    if (response[0] === 200) {
      setRoleList(response[1]);
    }
  };
  const handleDelete = (id: string) => {
    setSelectedId(id);
    setShowDeleteModal(true);
  };
  const handleCloseDelete = () => {
    setShowDeleteModal(false);
  };
  const deleteRole = async () => {
    const formData = new FormData();
    formData.append('id', selectedId);
    const response = await sendFetch('https://api-workspace.astin.net/api/company-role/delete-role', {
      method: 'POST',
      data: formData,
    });
    if (response[0] === 200) {
      setShowDeleteModal(false);
      updateRoleList();
      searchParams.delete('page');
      searchParams.delete('id');
      setSearchParams(searchParams);
    }
  };
  const openEdit = (id: string) => {
    searchParams.set('page', 'edit');
    searchParams.set('id', id);
    setSearchParams(searchParams);
  };
  console.log(roleList);
  return (
    <>
      <Modal
        open={showDeleteModal}
        onClose={handleCloseDelete}
      >
        <div style={{ borderColor: theme.colors.primaryColor, backgroundColor: theme.colors.secondaryColor }} className='delete-role-modal-wrapper'>
          <h3>Видалити роль?</h3>
          <p>Ви впевнені, що хочете видалити роль?</p>
          <div className='delete-role-modal-buttons'>
            <Button onClick={deleteRole} className='delete-role-modal-button' label='Видалити' primary />
            <Button onClick={handleCloseDelete} className='delete-role-modal-button' label='Скасувати' />
          </div>
        </div>
      </Modal>
      {!currentPage &&
        <div className='role-list-wrapper'>
          {loading ? <div className='role-list-loading'>
            <CircularProgress size={'24px'} sx={{ color: theme.colors.gray }} />
          </div> : roleList.length !== 0 ? roleList.map((role, index) => {
            return <RoleLine key={index} openEdit={openEdit} handleDelete={handleDelete} title={role.name} id={role.id} />;
          })
            : <div style={{ color: theme.colors.gray }}>У вас ще немає ролей</div>}
          <Button onClick={() => { handlePageChange('add'); }} className='add-role-button' label='Додати роль' />
        </div>
      }
      {currentPage === 'add' && <AddRole updateRoleList={updateRoleList} />}
      {currentPage === 'edit' && <EditRole handleDelete={handleDelete} roleList={roleList} updateRoleList={updateRoleList} />}
    </>
  );
}